import React from 'react';
import { getGuests } from '../../SearchEntryWidget/defaultData';
import styles from './GuestCounter.module.scss';
import { getIconBaseUrl } from '../../../utils/assets';
const AccessibleVan = ({ onAccessibleLinkPayload, accessibleAllowed, accessibleVansState, onAccessibleVanChange, analytics, }) => {
    if (onAccessibleLinkPayload) {
        return (<div className={styles.container}>
        <span className={styles.controls}>
          <img className={styles.icon} alt='accessible van checkbox' src={getIconBaseUrl('disabled.svg')}/>
          <button className={styles.link} onClick={() => {
                analytics === null || analytics === void 0 ? void 0 : analytics(onAccessibleLinkPayload);
                window === null || window === void 0 ? void 0 : window.open('/holidays/accessible', '_self');
            }}>
            Discover and book wheelchair accessible accommodation
          </button>
        </span>
      </div>);
    }
    if (onAccessibleVanChange) {
        return (<label className={styles.container}>
        <span className={styles.controls}>
          <img className={styles.icon} alt='accessible van checkbox' src={getIconBaseUrl('disabled.svg')}/>
          <span className={styles.title}>Accessible caravan required?</span>
        </span>
        <span className={styles.controls}>
          {accessibleAllowed ? (<>
              <input className={styles.hiddenSelectable} type='checkbox' onClick={() => onAccessibleVanChange(!accessibleVansState)} value={accessibleVansState === null || accessibleVansState === void 0 ? void 0 : accessibleVansState.toString()} defaultChecked={accessibleVansState}/>
              <span role='img' aria-label={accessibleVansState ? 'yes' : 'no'} className={`${styles.indicator} ${accessibleVansState ? styles.indicatorChecked : ''}`}/>
            </>) : (<span className={styles.controlsDisabled}>N/A</span>)}
        </span>
      </label>);
    }
    return null;
};
export const GuestCounter = ({ id, onChange = () => { }, types = getGuests(), state, dogsAllowed = true, dogsSelector = true, dogsAllowedText = 'Sorry, dogs are not allowed at this park', accessibleCaravan = false, onAccessibleVanChange = () => { }, onAccessibleLinkPayload, analytics, accessibleAllowed = true, }) => {
    return (<>
      {types.map(({ type, label, description, maxValue, minValue }) => {
            var _a;
            const inputId = id ? `${id}-counter-${type}` : `counter-${type}`;
            // TODO - Should we use the default values here too?
            const typeValue = (_a = state[type]) !== null && _a !== void 0 ? _a : (minValue || 0);
            return type === 'dogs' && !dogsAllowed && dogsSelector ? (<div key={type} className={styles.container}>
            <div className={styles.header}>
              <div className={styles.title}>{label}</div>
              <div className={styles.description}>{dogsAllowedText}</div>
            </div>
            <div className={styles.controls}>
              <span className={styles.controlsDisabled}>N/A</span>
            </div>
          </div>) : type === 'dogs' && !dogsSelector ? null : (<div key={type} className={styles.container}>
            <div className={styles.header}>
              <label htmlFor={inputId} className={styles.title}>
                {label}
              </label>
              <div className={styles.description}>{description}</div>
            </div>
            <div className={styles.controls}>
              <button type='button' className={`${styles.button} ${styles.minus}`} data-field='quantity' disabled={typeValue <= minValue} onClick={() => onChange(type, typeValue - 1)} data-test-guest-selector-minus-button={`${type}-minus-button`}>
                -
              </button>{' '}
              <input id={inputId} max={maxValue} min={minValue} step={1} type='number' readOnly value={typeValue} className={styles.hidden} name='quantity'/>
              <div className={styles.display} data-test-guest-selector-display='gueast-display'>
                {typeValue}
              </div>
              <button type='button' className={styles.button} data-field='quantity' disabled={typeValue >= maxValue} onClick={() => onChange(type, typeValue + 1)} data-test-guest-selector-plus-button={`${type}-plus-button`}>
                +
              </button>
            </div>
          </div>);
        })}
      {accessibleCaravan && (<AccessibleVan accessibleVansState={state.accessibleVans} onAccessibleLinkPayload={onAccessibleLinkPayload} onAccessibleVanChange={onAccessibleVanChange} analytics={analytics} accessibleAllowed={accessibleAllowed}/>)}
    </>);
};
export default GuestCounter;
